import { render, staticRenderFns } from "./consumerInsightPieChart.vue?vue&type=template&id=9bc4fa18&scoped=true&"
import script from "./consumerInsightPieChart.vue?vue&type=script&lang=js&"
export * from "./consumerInsightPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bc4fa18",
  null
  
)

export default component.exports